import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import PopUp from '../../../../Shared/Popup/PopUp';
import user from './images/userBigCopy.svg';
import {deleteContact} from '../../fundialSlice';


const RemoveContact = (props) => {

    function removeSongBtn(){
        props.deleteContact({subscriber: props.subscriber.cli , profileId: props.data.id  });
        props.close();
    }

    return (
        <PopUp className="fundial-remove-contact-popup" showPopUp={props.show} onClose={props.close}>
            <div className="remove-contact-wrapper" >
                <div className="title">
                    <Image src={user} className="contact-icon" />
                    <h1>הסרת איש קשר</h1>
                </div>
                <div className="chosen-contact">
                    <p className="sub-title">האם להסיר את איש הקשר?</p>
                    <p className="contact-number">{props.data.cli}</p>
                </div>
                <div className="description">
                   <p>
                   לאחר אישור ביצוע הפעולה איש הקשר הזה לא ישמע יותר את השיר שבחרת
                   </p>
                </div>
                <div className="btn-wrapper">
                    <button onClick={() => props.close()} className="cancel-btn">ביטול</button>
                    <BtnSubmit onclick={() => removeSongBtn()} text="אישור הסרה" formid="fundial-remove-song"></BtnSubmit>
                </div>
            </div>
        </PopUp> 
    ) ;
}


const mapStateToProps = (state) => {
    return {
        subscriber: state.fundialPage.selectedSubscriber,
    };
  };
  
  const mapDispatchToProps = {
    deleteContact
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(RemoveContact);